(function ($) {

	function init_archive_hover_image_load_listener(){

		// Events:
		// load - for images
		// loadeddata - for videos
		$('.product-card.-has-bg').hover(function(){

			// Find image element
			var $hover_image = $(this).find('.product-card__bg_content');

			// Show element to load
			$hover_image.show();

			// Add class to content on load
			// load for images, loadeddata for videos
			$hover_image.on("load loadeddata", () => {
				$(this).addClass('hover-image-loaded');
			})
		})

	}

	$(document).gp_ready(init_archive_hover_image_load_listener);
	$(document).gp_on("product_variation_switched", init_archive_hover_image_load_listener)

})(jQuery);
